{
  "version": 1,
  "asset_id": "accaadb7-4ee7-4264-9264-b3a5c4afc208",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/accaadb7-4ee7-4264-9264-b3a5c4afc208/destination-roofing-crew-citrus-county-fl-640.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/accaadb7-4ee7-4264-9264-b3a5c4afc208/destination-roofing-crew-citrus-county-fl-640.webp",
  "original_filename": "destination-roofing-crew-citrus-county-fl-640.webp",
  "size": 42392,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:33Z"
}
